<template>
    <div>
        <div v-if="showpage === 'canTest'" class="examTaking">
            <van-nav-bar :title="duration" :style="{ paddingTop: statusBarHeight + 'px' }">
                <template #left left-arrow>
                    <i @click="onTopic()" class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
                    <span>
                        {{ ConstData.questionType[currentQuestion.type].text }}题 / {{ currentQuestion.score }}分
                    </span>
                </template>
                <template #right>
                    <span style="font-size: 22px; color: #202124; padding-right: 5px">
                        {{ currentRanking }}
                    </span>
                    <span style="padding-top: 3px">/ {{ examTotal }}</span>
                </template>
            </van-nav-bar>
            <!-- 题目内容 -->
            <div class="examContent" :style="currentQuestion.type === 6 ? 'padding-bottom:0' : ''">
                <h3 class="examContent-topic" v-if="+currentQuestion.type !== 7" v-html="currentQuestion.title">
                    {{ currentQuestion.title }}
                </h3>
                <div class="completionBox" v-if="+currentQuestion.type === 6">
                    <div class="completionItem" v-for="(item, index) in currentQuestion.completionAnswer" :key="index">
                        <p class="label">{{ index + 1 }}：</p>
                        <input
                            type="text"
                            v-model="item.answer"
                            class="inp"
                            placeholder="请输入答案"
                            @blur="completionBlur()"
                        />
                    </div>
                </div>
                <div class="completionBox" v-if="+currentQuestion.type === 7">
                    <!-- 组合题 -->
                    <div>
                        <div class="combination-title">
                            <span class="left">{{ currentQuestion.questionNo + 1 }}.</span>
                            <span class="content" v-html="currentQuestion.title" />
                        </div>
                        <div class="examContent-option">
                            <div class="combination-title subTitle">
                                <div class="left">
                                    <span class="subScore">{{ subScore }}</span>
                                    <span>{{ currentQuestion.questionNo + 1 }}.{{ subQuestion.questionIdx + 1 }}</span>
                                </div>
                                <span class="content" v-html="subQuestion.title" />
                            </div>
                            <!-- 组合题内填空题 -->
                            <div class="completionBox" v-if="subQuestion.type == 6">
                                <div
                                    class="completionItem"
                                    v-for="(item, index) in subQuestion.completionAnswer"
                                    :key="index"
                                >
                                    <p class="label">{{ index + 1 }}：</p>
                                    <input
                                        type="text"
                                        v-model="item.answer"
                                        class="inp"
                                        placeholder="请输入答案"
                                        @blur="zuheCompletionBlur()"
                                    />
                                </div>
                            </div>
                            <!-- 组合题内简单题 -->
                            <div v-else-if="+subQuestion.type === 5">
                                <QAquestions
                                    v-if="!justWatch && QAquestionsFlag"
                                    :combinationFlag="true"
                                    :currentQuestion="currentQuestion"
                                    :subQuestion="subQuestion"
                                    :moreChoose.sync="moreChoose"
                                    :currentParams.sync="currentParams"
                                    :questionsList.sync="questionsList"
                                />
                            </div>
                            <ul v-else>
                                <li
                                    v-for="(item, index) in subQuestion.optionList"
                                    @click="activebtn(item)"
                                    :class="chooseColor(item)"
                                    :key="index"
                                >
                                    <span>{{ item.optionNumber }}.</span>
                                    <p class="optionContent" v-html="item.optionContent">
                                        {{ item.optionContent }}
                                    </p>
                                    <span v-if="chooseColor(item) === 'activeSpan' && justWatch">
                                        <svg-icon icon-class="right-icon" class-name="right-icon"></svg-icon>
                                    </span>
                                    <span v-if="chooseColor(item) === 'cuoSpan' && justWatch">
                                        <svg-icon icon-class="wrong-icon" class-name="wrong-icon"></svg-icon>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- 简单题 -->
                <div v-else-if="+currentQuestion.type === 5 && !justWatch">
                    <QAquestions
                        v-if="QAquestionsFlag"
                        :currentQuestion="currentQuestion"
                        :subQuestion="subQuestion"
                        :moreChoose.sync="moreChoose"
                        :currentParams.sync="currentParams"
                        :questionsList.sync="questionsList"
                    />
                </div>
                <div class="examContent-option" v-else>
                    <ul>
                        <li
                            v-for="(item, index) in currentQuestion.options"
                            @click="activebtn(item)"
                            :class="chooseColor(item)"
                            :key="index"
                        >
                            <span>{{ item.optionNumber }}.</span>
                            <p class="optionContent" v-html="item.optionContent">{{ item.optionContent }}</p>
                            <span v-if="chooseColor(item) === 'activeSpan' && justWatch">
                                <svg-icon icon-class="right-icon" class-name="right-icon"></svg-icon>
                            </span>
                            <span v-if="chooseColor(item) === 'cuoSpan' && justWatch">
                                <svg-icon icon-class="wrong-icon" class-name="wrong-icon"></svg-icon>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 考试分析 -->
            <div
                class="exam-analysis"
                :class="{
                    'exam-analysis-completion': [5, 6].includes(questionType)
                }"
                v-if="justWatch"
            >
                <template v-if="questionType == 5">
                    <QAdetails :justWatch="justWatch" :echoedData="echoedData" />
                </template>
                <template v-else>
                    <div class="analysis-type" v-if="questionType !== 6">
                        <span class="choose">
                            正确答案：
                            <span class="analyOption">{{ echoedData.rightAnswer }}</span>
                        </span>
                        <span class="choose">
                            您的答案：
                            <span :class="echoedData.result !== 1 ? 'noanalyOption' : 'analyOption'">
                                {{ echoedData.userAnswer || '未答' }}
                            </span>
                        </span>
                    </div>
                    <div class="completionBox" v-if="questionType === 6">
                        <div class="myAnswer">
                            <div
                                class="myAnswer-item"
                                :class="completionItem.result === 0 ? 'errorAnswer' : ''"
                                v-for="(completionItem, index) in echoedData.userAnswer2Complete"
                                :key="'completionItem' + index"
                            >
                                <span>{{ index + 1 }}： {{ completionItem.optionContent }}</span>
                                <p>
                                    <svg-icon
                                        :icon-class="completionItem.result ? 'right-icon' : 'wrong-icon'"
                                        :class-name="completionItem.result ? 'right-icon' : 'wrong-icon'"
                                    />
                                </p>
                            </div>
                        </div>
                        <div class="rightAnswer">
                            <p class="label">正确答案：</p>
                            <div
                                class="rightAnswerItem"
                                v-for="(rightAnswerItem, index) in echoedData.rightAnswer.split(',')"
                                :key="'rightAnswerItem' + index"
                            >
                                {{ index + 1 }}：
                                {{ rightAnswerItem }}
                            </div>
                            <p class="stjx">试题解析</p>
                            <p v-html="echoedData.remark" class="analysis-content optionContent">
                                {{ echoedData.remark ? echoedData.remark : '无' }}
                            </p>
                        </div>
                    </div>
                    <div v-if="questionType !== 6">
                        <p class="stjx">试题解析</p>
                        <p v-html="echoedData.remark" class="analysis-content optionContent">
                            {{ echoedData.remark ? echoedData.remark : '无' }}
                        </p>
                    </div>
                </template>
            </div>
            <div class="bottomBtn">
                <div class="tubiao">
                    <p v-if="!justWatch" @click="handleMark()">
                        <img ref="mark" :data-status="ismark" :src="biaojiImg" alt />
                        <span>标记</span>
                    </p>
                    <p @click="isSheetShow = !isSheetShow">
                        <svg-icon icon-class="sheet-icon" class-name="sheet-icon"></svg-icon>
                        <span>答题卡</span>
                    </p>
                </div>
                <div class="btn">
                    <van-button v-if="!justWatch" plain round type="info" class="commit" @click="commitPaper()">
                        交卷
                    </van-button>
                    <!-- 组合题按钮 -->
                    <template v-if="combinationFlag">
                        <van-button
                            :disabled="subQuestion.first && currentRanking === 1"
                            round
                            type="info"
                            class="changeBtn"
                            @click="changeTopic({ type: 'prev' })"
                        >
                            上一题
                        </van-button>
                        <van-button
                            :disabled="subQuestion.lastOne && currentRanking === examTotal"
                            round
                            type="info"
                            class="changeBtn"
                            @click="changeTopic({ type: 'next' })"
                        >
                            下一题
                        </van-button>
                    </template>
                    <!-- 普通题型按钮 -->
                    <template v-else>
                        <van-button
                            :disabled="currentRanking === 1"
                            round
                            type="info"
                            class="changeBtn"
                            @click="changeTopic({ type: 'prev' })"
                        >
                            上一题
                        </van-button>
                        <van-button
                            :disabled="currentRanking === examTotal"
                            round
                            type="info"
                            class="changeBtn"
                            @click="changeTopic({ type: 'next' })"
                        >
                            下一题
                        </van-button>
                    </template>
                </div>
                <div :style="{ height: bottomSafeHeight + 'px', width: '100%' }"></div>
            </div>
            <!-- 答题卡 -->
            <van-action-sheet v-model="isSheetShow" title="答题卡" :close-on-click-action="true">
                <span class="examTotal">/共{{ examTotal }}题</span>
                <div class="sheet-content">
                    <div class="sheet-content-type">
                        <span class="answered">
                            {{ justWatch ? '正确' : '已答' }}
                            <span class="answered-num" v-if="!combination">
                                {{ justWatch ? paperInfo.rightCount : rightCount }}
                            </span>
                        </span>
                        <span class="error" v-if="justWatch">
                            错误
                            <span class="answered-num" v-if="!combination">
                                {{ justWatch ? paperInfo.errorCount : '' }}
                            </span>
                        </span>
                        <span class="unanswered">
                            未答
                            <span class="answered-num" v-if="!combination">
                                {{ justWatch ? paperInfo.emptyCount : examTotal - rightCount }}
                            </span>
                        </span>
                    </div>
                </div>
                <div class="sheet-num" v-for="(item, index) in questionsHandle" :key="index">
                    <div class="hang">
                        <div class="topicBox">
                            <span class="topicType">{{ item.topicType }}</span>
                            <span class="score">/共{{ item.total }}题 合计{{ item.score }}分</span>
                        </div>
                        <template v-for="(itemVal, indexVal) in item.values">
                            <!-- 组合题 -->
                            <div :key="indexVal" v-if="item.type == 7">
                                <div class="topicBox">
                                    <span class="topicType noLine">{{ indexVal + 1 }}.组合题{{ indexVal + 1 }}</span>
                                    <span class="score">
                                        /共{{ itemVal.subDtoList.length }}题 合计{{ itemVal.score }}分
                                    </span>
                                </div>
                                <span
                                    v-for="(subDto, idx) in itemVal.subDtoList"
                                    :key="idx"
                                    class="grade"
                                    :class="setColor(subDto)"
                                    @click="toThisOne(itemVal.questionNo, subDto.questionIdx)"
                                >
                                    {{ itemVal.questionNo + 1 }}.{{ idx + 1 }}
                                    <img
                                        v-if="subDto.mark"
                                        class="biaojiTopic"
                                        src="../../../assets/images/exam/biaojibai.png"
                                    />
                                </span>
                            </div>
                            <span
                                v-else
                                :key="indexVal"
                                class="grade"
                                :class="setColor(itemVal)"
                                @click="toThisOne(itemVal.questionNo)"
                            >
                                {{ itemVal.questionNo + 1 }}
                                <img
                                    v-if="itemVal.mark"
                                    class="biaojiTopic"
                                    src="../../../assets/images/exam/biaojibai.png"
                                />
                            </span>
                        </template>
                    </div>
                </div>
                <div v-if="!justWatch">
                    <van-button
                        style="width: 100%; font-size: 16px; font-weight: 550; margin-top: 40px"
                        round
                        type="info"
                        @click="commitPaper()"
                    >
                        交卷
                    </van-button>
                </div>
            </van-action-sheet>
            <van-dialog v-model="faceCheck" title :show-confirm-button="false">
                <img src="../../../assets/images/exam/face.png" alt />
                <h2>人脸识别</h2>
                <p>交卷前需进行人脸验证，是否交卷？</p>
                <van-button class="faceBtn" round type="info" @click="openFaceCheck('commit')">交卷</van-button>
                <van-button v-if="!autoTime" class="faceBtn1" round type="info" plain @click="faceCheck = false">
                    继续答题
                </van-button>
                <van-button class="faceBtn1" round type="info" plain @click="abandonExam">放弃考试</van-button>
            </van-dialog>
            <!-- 最少答题时间 -->
            <van-dialog class="allowtime" v-model="allowCheck" title :show-confirm-button="false">
                <img class="allowImg" src="../../../assets/images/exam/examtip@2x.png" alt />
                <h2 class="allowH2">提示</h2>
                <!-- {{examParams.allowCommitDuration}} -->
                <p class="allowP">
                    本次考试限制提前交卷，请在
                    <span>{{ allowparams.surplusTime }}</span>
                    分钟后再尝试提交试卷
                    <!-- 当前已过
                <span>{{allowparams.pastTime}} </span>分钟，请在
                <span>{{allowparams.surplusTime}} </span>分钟后交卷 -->
                </p>
                <van-button class="allowBtn2 allowBtn" round type="info" plain @click="allowCheck = false">
                    我知道了（{{ allowtime }}S后关闭）
                </van-button>
            </van-dialog>
            <div id="examTaking"></div>
            <van-dialog
                v-if="!justWatch && switchScreenNum != -1"
                class="cutScreenDialog"
                v-model="warningDialogVisible"
                width="15.733rem"
                height="15.978rem"
            >
                <img src="../../../assets/images/exam/warning.png" class="warning-img" alt="" />
                <div class="warningTitle">警告</div>
                <!-- <div class="warningText" slot="default" v-if="cutNum < switchScreenNum">
                你试图离开考试页面，警告{{ cutNum }}次 （超过{{
                switchScreenNum
                }}次，系统将强制交卷!）
            </div>
            <div class="warningText" slot="default" v-if="cutNum >= switchScreenNum">
                检测到您已累计{{ switchScreenNum }}次试图离开考试页面
                系统将强制提交试卷！
            </div> -->
                <div class="warningText" slot="default">检测到切屏{{ cutNum }}次，请勿切换页面，遵守考试纪律！</div>
                <van-button class="warningBtn" @click="know()">知道了（{{ warningTime }}S后关闭）</van-button>
            </van-dialog>
        </div>
        <div class="warningPage" v-if="showpage === 'notTest'">
            <img src="../../../assets/images/exam/examWarning.png" alt="" />
        </div>
    </div>
</template>

<script>
import { Dialog } from 'vant'
import examMixin from './../../../utils/examMixin.js'
import { formateHours, formatTime } from '../libs/timeformate.js'
import QAquestions from './QAquestions'
import QAdetails from './../components/QAdetails'
export default {
    name: 'examTaking',
    components: { QAquestions, QAdetails },
    data() {
        return {
            justWatch: false,
            faceCheck: false,
            allowCheck: false,
            combination: false, // 题目中是否有组合题
            QAquestionsFlag: true, // hack处理连续的问答题在一起时，外面数据变化，内部钩子函数不执行
            ismark: 0,
            examtime: '00:09:10',
            biaojiImg: require('../../../assets/images/exam/nobiaoji.png'),
            isSheetShow: false,
            questionsList: [],
            examTotal: null,
            examType: ['单选', '多选', '判断', '高阶'],
            currentQuestion: {}, // 当前选择的大题
            subQuestion: {}, // 组合题中的子题=>只针对组合题
            currentParams: null, // 当前题目的Params
            currentRanking: 1,
            duration: '',
            chooseNum: null,
            singleParams: {},
            allAnswer: [],
            moreanswer: [],
            moreChoose: null,
            rightCount: 0,
            errorCount: null,
            emptyCount: null,
            paperInfo: {},
            examParams: {
                userPaperId: null,
                examId: null
            },
            allowparams: {
                pastTime: null,
                surplusTime: null
            },
            historyExamInfo: {},
            autoTime: null,
            showpage: '',
            switchScreenNum: null,
            cutNum: 0,
            warningDialogVisible: false,
            isFaceRecogCommitExam: null,
            isFaceRecogDuringExam: null,
            warningTime: 3,
            allowtime: 5,
            warningInterval: null,
            allowtimeInterval: null,
            isValid: null,
            halfTime: 0,
            startTime: null,
            statusBarHeight: 0,
            bottomSafeHeight: 0
        }
    },
    mixins: [examMixin],
    computed: {
        // 子题分数
        subScore() {
            let str = ''
            const type = this.subQuestion.type
            if (type || type == 0) str = this.ConstData.questionType[type].text + '/' + this.subQuestion.score + '分'
            return str
        },
        questionType() {
            // 当前正在答题的类型，已小题为维度 有些地方的类型判断，还是要以大题的类型为准
            if (this.combinationFlag) {
                return this.subQuestion.type
            } else {
                return this.currentQuestion.type
            }
        },
        echoedData() {
            // 回显的数据
            let data = null
            if (this.combinationFlag) {
                data = this.subQuestion
            } else {
                data = this.currentQuestion
            }
            return data
        }
    },
    watch: {
        allAnswer(val) {
            let faceflag = localStorage.getItem('faceidentify')
            //答题过半人脸识别
            if (this.examTotal === 1) {
                return
            }
            if (
                val.length === Math.ceil(this.examTotal / 2) &&
                (!faceflag || faceflag === '0') &&
                +this.isFaceRecogDuringExam
            ) {
                this.openFaceCheck('pending')
            }
        },
        currentQuestion(val) {
            console.log(val, 'currentQuestion===')
            if (val) {
                // 填空题如果只有一个空并且未作答的情况
                if (val.type === 6 && val.userAnswer === '' && val.completeInputNum) {
                    val.userAnswer2Complete = []
                    for (let i = 0; i < val.completeInputNum; i++) {
                        val.userAnswer2Complete.push({
                            id: null,
                            optionContent: null,
                            optionContentWithoutTag: null,
                            optionNumber: null,
                            optionScore: null,
                            questionId: null,
                            result: 0,
                            sort: null
                        })
                    }
                }
                this.markChange(val)
            }
        },
        subQuestion(val) {
            // 监听子题数据变化
            console.log(val, 'subQuestion更新了', 'currentQuestion:', this.currentQuestion)
            this.markChange(val)
        },
        ismark(val) {
            if (this.combinationFlag) {
                this.subQuestion.mark = val
            } else this.currentQuestion.mark = val
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.path === '/reading') {
            localStorage.removeItem('faceidentify')
        }
        window.history.pushState(null, null, '#')
        next()
    },
    beforeDestroy() {
        window.removeEventListener('pagehide', this.refreshParam)
        window.removeEventListener('beforeunload', this.refreshParam)
        window.removeEventListener('visibilitychange', this.cutScreen)
        window.removeEventListener('popstate', this.backChange, false) //false阻止默认事件
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
        setTimeout(() => {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }, 2000)
    },
    created() {
        this.startTime = new Date()
        if (localStorage.getItem('type') == 'iOS') {
            this.statusBarHeight = localStorage.getItem('statusBarHeight')
            this.bottomSafeHeight = localStorage.getItem('bottomSafeHeight')
        }
    },
    methods: {
        // 标记状态变化
        markChange(val) {
            this.ismark = val.mark ? val.mark : 0
            this.biaojiImg =
                this.ismark === 0
                    ? require('../../../assets/images/exam/nobiaoji.png')
                    : require('../../../assets/images/exam/biaoji.png')
            if (this.justWatch) {
                if (val.type !== 2) {
                    this.chooseNum = val.userAnswer
                    this.moreanswer = null
                } else {
                    this.moreanswer = val.userAnswer
                    this.chooseNum = null
                }
            }
            // hack处理连续的问答题在一起时，外面数据变化，内部钩子函数不执行
            this.QAquestionsFlag = false
            this.$nextTick(() => (this.QAquestionsFlag = true))
        },
        // 填空题失去焦点
        completionBlur() {
            let params = {
                answer: '',
                mark: this.currentQuestion.mark === undefined ? 0 : this.currentQuestion.mark,
                questionId: this.currentQuestion.questionId,
                questionType: this.currentQuestion.type
            }
            let answer = []
            let num = 0
            this.currentQuestion.completionAnswer.forEach(item => {
                if (item.answer !== '') num++
                answer.push(item.answer)
            })
            console.log(this.currentQuestion, answer, 'this.currentQuestion')
            if (num) {
                this.questionsList[this.currentRanking - 1].responds = 1
                params.answer = answer.join(',')
            } else {
                this.questionsList[this.currentRanking - 1].responds = 0
            }
            this.$set(this.questionsList, this.currentRanking - 1, this.questionsList[this.currentRanking - 1])
            this.moreChoose = { ...params }
            this.currentParams = params
        },
        // 组合填空失去焦点
        zuheCompletionBlur() {
            let params = {
                answer: '',
                mark: this.currentQuestion.mark === undefined ? 0 : this.currentQuestion.mark,
                questionId: this.subQuestion.parentId,
                questionType: this.currentQuestion.type,
                subQuestionId: this.subQuestion.id, // 当前选项所在题id
                subQuestionType: this.subQuestion.type ?? null
            }
            let answer = [],
                num = 0
            this.subQuestion.completionAnswer.forEach(item => {
                if (item.answer !== '') num++
                answer.push(item.answer)
            })
            if (num) {
                this.subQuestion.responds = 1
                params.answer = answer.join(',')
            } else this.subQuestion.responds = 0
            // this.$set(this.questionsList, this.currentRanking - 1, this.questionsList[this.currentRanking - 1])
            this.moreChoose = { ...params }
            this.currentParams = params
        },
        setWarning() {
            this.warningInterval = setInterval(() => {
                this.warningTime = this.warningTime - 1
                if (this.warningTime == 1) {
                    this.know()
                    clearInterval(this.warningInterval)
                }
            }, 1000)
            this.warningTime = 3
        },
        setallowtime() {
            this.allowtimeInterval = setInterval(() => {
                this.allowtime = this.allowtime - 1
                if (this.allowtime == 1) {
                    this.allowCheck = false
                    clearInterval(this.allowtimeInterval)
                }
            }, 1000)
            this.allowtime = 5
        },
        removeItem() {
            sessionStorage.removeItem('historyExamInfo')
            sessionStorage.removeItem('autoTime')
            sessionStorage.removeItem('examStatus')
            sessionStorage.removeItem('hiddenpageTime')
            sessionStorage.removeItem('openpageTime')
            sessionStorage.removeItem('examSurplusTime')
        },
        getConfirm(type) {
            console.log('sdsadsa============', type)
            this.$dialog
                .confirm({
                    title: '身份验证',
                    message: '请进行人脸识别验证',
                    closeOnPopstate: false,
                    showCancelButton: false,
                    className: 'examTakingDialog'
                })
                .then(() => {
                    var faceidentifylocalUrl = window.location.href
                    localStorage.setItem('faceidentifylocalUrl', faceidentifylocalUrl)
                    this.$router.push({
                        path: '/faceidentify',
                        query: {
                            faceType: type,
                            businessId: this.examParams.userPaperId
                        }
                    })
                })
        },
        backChange() {
            if (!this.justWatch) {
                window.history.pushState(null, null, '#')
            } else if (this.justWatch) {
                this.$router.push({
                    path: '/examlistDetails',
                    query: {
                        trainId: this.$route.query.businessId,
                        type: this.$route.query.businessType,
                        contentId: this.$route.query.examId,
                        backType: this.$route.query.backType,
                        backPath: this.$route.query.backPath,
                        goodsId: this.$route.query.goodsId,
                        goodsKind: this.$route.query.goodsKind
                    }
                })
                // this.$router.push({
                //     // path: this.isValid ? "/examresults" : '/examIsValid',
                //     path: "/examresults",
                //     query: {
                //         id: this.examParams.userPaperId,
                //         businessType: this.$route.query.businessType,
                //         businessId: this.$route.query.businessId,
                //         trainItemExamId: this.$route.query.trainItemExamId,
                //         backType: this.$route.query.backType,
                //         showbtn: this.$route.query.showbtn,
                //         backPath: this.$route.query.backPath,
                //         goodsId: this.$route.query.goodsId,
                //         goodsKind: this.$route.query.goodsKind,
                //     }
                // });
            }
        },
        //交卷前需要人脸识别
        async openFaceCheck(type) {
            this.isSheetShow = false
            this.setHistory()
            // 考后
            if (type === 'commit') {
                sessionStorage.setItem('examStatus', 'commit')
                this.faceCheck = false
                this.getConfirm('3')
            }
            // 考中
            if (type === 'pending') {
                sessionStorage.setItem('examStatus', 'pendingCommit')
                this.faceCheck = false
                this.getConfirm('2')
            }

            await clearInterval(this.timer)
        },
        abandonExam() {
            window.removeEventListener('beforeunload', this.refreshParam)
            window.removeEventListener('pagehide', this.refreshParam)
            this.removeItem()
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            setTimeout(() => {
                if (this.timer) {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 2000)
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: this.$route.query.businessId,
                    type: this.$route.query.businessType,
                    contentId: this.$route.query.examId,
                    backType: this.$route.query.backType,
                    backPath: this.$route.query.backPath,
                    goodsId: this.$route.query.goodsId,
                    goodsKind: this.$route.query.goodsKind
                }
            })
        },
        // 如果是单选、判断直接进入下一题
        activebtn(val) {
            console.log('点击的选项', val, this.justWatch)
            if (this.justWatch) return false
            // questionId 表示当前大题id
            const questionId = this.combinationFlag ? this.currentQuestion.questionId : val.questionId
            const subQuestionId = this.combinationFlag ? val.questionId : null
            let params = {
                answer: '',
                mark: this.currentQuestion.mark === undefined ? 0 : this.currentQuestion.mark,
                questionId: questionId,
                questionType: this.currentQuestion.type,
                subQuestionId: subQuestionId, // 当前选项所在题id
                subQuestionType: this.subQuestion.type ?? null
            }
            // 单选、判断、不是多选的走这个
            console.log(this.questionType, '单选、判断、不是多选的走这个')
            if (this.questionType !== 2) {
                this.chooseNum = null
                if (this.combinationFlag) {
                    this.subQuestion.responds = 1
                }
                this.questionsList[this.currentRanking - 1].responds = 1
                params.answer = val.optionNumber
                this.chooseNum = val.optionNumber
                this.$set(this.questionsList, this.currentRanking - 1, this.questionsList[this.currentRanking - 1])
                this.repetAnswer(params)
                this.currentParams = params
                console.log(7777, params, this.currentRanking, this.examTotal, this.combinationFlag, this.subQuestion)
                if (this.combinationFlag) {
                    // 组合题中子题最后一道题，同时当前也是大题的最后一道题，不自动提交
                    if (this.subQuestion.lastOne && this.currentRanking === this.examTotal) return false
                    this.singleCommit(params)
                } else {
                    if (this.currentRanking !== this.examTotal) {
                        this.singleCommit(params)
                    }
                }
                console.log(this.questionsList, 'questionsList==')
            } else {
                // 多选
                let isoption = this.moreanswer.indexOf(val.optionNumber)
                if (this.moreanswer.length === 0 || isoption === -1) {
                    this.moreanswer.push(val.optionNumber)
                    this.chooseNum = val.optionNumber
                } else if (isoption !== -1) {
                    this.chooseNum = null
                    this.moreanswer.splice(isoption, 1)
                }
                if (this.combinationFlag) {
                    this.subQuestion.responds = this.moreanswer.length === 0 ? 0 : 1
                }

                this.questionsList[this.currentRanking - 1].responds = this.moreanswer.length === 0 ? 0 : 1
                this.$set(this.questionsList, this.currentRanking - 1, this.questionsList[this.currentRanking - 1])

                params.answer = this.moreanswer.toString()
                this.moreChoose = { ...params }
                this.currentParams = params
            }
        },
        // 全部题目提交
        async allCommit(type) {
            console.log(this.allAnswer, 'this.allAnswer---allCommit')
            // 单个提交
            // await this.$api.coursetest.userPaperCommitPaper({
            //   answerList: [this.currentParams],
            //   commitTime: formatTime(new Date()),
            //   userPaperId: this.examParams.userPaperId
            // });
            // 全部提交
            this.singleParams = {
                answerList: this.allAnswer,
                commitTime: this.autoTime ? this.autoTime : formatTime(new Date()),
                userPaperId: this.examParams.userPaperId
            }
            let getfaceparams = localStorage.getItem('faceidentify')
            // 人脸识别是否成功
            let isfaceSucc =
                (+this.isFaceRecogCommitExam || +this.isFaceRecogDuringExam) && getfaceparams === '0' ? 1 : ''
            // this.singleParams.invalidType = type === 'cut' ? 2: isfaceSucc
            this.singleParams.invalidType = type === 'voluntarily' ? 9 : isfaceSucc
            let data = this.singleParams
            Dialog.close()
            await this.$api.exam.commitAllPaper({ data })
            this.removeItem()
            // 结果页
            // this.$router.push({
            //     // path: type === 'cut' || isfaceSucc === 1 ? "/examIsValid" : "/examresults",
            //     path: '/examresults',
            //     query: {
            //         id: this.examParams.userPaperId,
            //         businessType: this.$route.query.businessType,
            //         businessId: this.$route.query.businessId,
            //         trainItemExamId: this.$route.query.trainItemExamId,
            //         backType: this.$route.query.backType,
            //         backPath: this.$route.query.backPath,
            //         goodsId: this.$route.query.goodsId,
            //         goodsKind: this.$route.query.goodsKind,
            //     }
            // });
            //
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: this.$route.query.businessId,
                    type: this.$route.query.businessType,
                    contentId: this.$route.query.examId,
                    backType: this.$route.query.backType,
                    backPath: this.$route.query.backPath,
                    goodsId: this.$route.query.goodsId,
                    goodsKind: this.$route.query.goodsKind
                }
            })
        },
        commitPaper(flag) {
            let moretime = null
            let pastTime = null
            if (!+this.examParams.seconds) {
                let past = (new Date() - this.startTime) / 1000 / 60
                this.allowparams.pastTime = Math.floor(past)
                pastTime = new Date() - this.startTime
                moretime = false
            } else {
                this.allowparams.pastTime = Math.floor((this.examParams.seconds - this.examtime) / 60) // 过去多少时间
                pastTime = this.examParams.seconds - this.examtime
                moretime = this.examParams.allowCommitDuration * 60 > this.examParams.seconds
            }
            this.allowparams.surplusTime = this.examParams.allowCommitDuration - this.allowparams.pastTime // 剩余多少时间
            if (
                !moretime &&
                pastTime > 1 &&
                this.allowparams.surplusTime > 0 &&
                +this.examParams.allowCommitDuration !== 0
            ) {
                this.allowCheck = true
                this.setallowtime()
            } else {
                this.allowCheck = false
                this.pushState()
                if (this.moreChoose) {
                    this.repetAnswer(this.moreChoose)
                }
                let noanswer = this.allAnswer.length < this.examTotal
                if (flag !== 1) {
                    // eslint-disable-next-line no-extra-semi
                    ;+this.isFaceRecogCommitExam === 1
                        ? (this.faceCheck = true)
                        : Dialog.confirm({
                              message: noanswer ? '你还有题目未作答，确认交卷？' : '是否要进行交卷？',
                              confirmButtonText: '交卷',
                              cancelButtonText: '继续答题',
                              className: 'dtconfirm'
                          })
                              .then(() => {
                                  this.allCommit()
                              })
                              .catch(() => {
                                  this.pushState()
                              })
                } else {
                    console.log(+this.isFaceRecogCommitExam === 1, '+this.isFaceRecogCommitExam === 1')
                    ;+this.isFaceRecogCommitExam === 1 ? (this.faceCheck = true) : this.allCommit('voluntarily')
                }
            }
        },
        // 倒计时
        countDown(open) {
            clearInterval(this.timer)
            const self = this
            if (open) {
                this.examtime = open
            } else if (!this.historyExamInfo) {
                // self.examtime *= 60;
            } else {
                if (typeof this.historyExamInfo.examtime === 'string') {
                    let second = this.historyExamInfo.examtime.split(':')
                    self.examtime = parseInt(second[0]) * 3600 + parseInt(second[1]) * 60 + parseInt(second[2])
                } else {
                    self.examtime = this.historyExamInfo.examtime
                }
            }
            this.timer = setInterval(async () => {
                if (self.examtime > -1) {
                    this.duration = formateHours(self.examtime)
                    self.examtime -= 1
                    this.halfTime += 1
                    if (self.examtime === 300 || self.examtime === 60) {
                        let audioText = `距离考试结束：剩余${self.examtime / 60}分钟`
                        this.$toast({
                            message: audioText
                        })
                        await this.audioplay(audioText)
                    }
                    let faceflag = localStorage.getItem('faceidentify')
                    //时间过半进行人脸识别
                    if (
                        +this.isFaceRecogDuringExam === 1 &&
                        this.halfTime === self.examtime &&
                        (!faceflag || faceflag === '0')
                    ) {
                        this.openFaceCheck('commit')
                    }
                } else {
                    await clearInterval(this.timer)
                    sessionStorage.setItem('autoTime', formatTime(new Date()))
                    if (
                        (this.historyExamInfo && this.historyExamInfo.status !== 'over') ||
                        +this.isFaceRecogCommitExam === 0
                    ) {
                        console.log(
                            this.historyExamInfo && this.historyExamInfo.status,
                            '===',
                            +this.isFaceRecogCommitExam
                        )
                        Dialog.alert({
                            message: '考试时间已到，系统自动交卷'
                        }).then(() => {
                            if (+this.isFaceRecogCommitExam === 1) {
                                this.autoTime = sessionStorage.getItem('autoTime')
                                this.faceCheck = true
                            }
                        })
                    }
                    if (+this.isFaceRecogCommitExam === 0) {
                        setTimeout(() => {
                            this.commitPaper(1)
                            Dialog.close()
                        }, 3000)
                    }
                }
            }, 1000)
        },
        // 获取试题列表
        async findQuestForExam() {
            const { data } = await this.$api.exam.findQuestForExam({
                userPaperId: this.examParams.userPaperId,
                examId: this.$route.query.examId
            })
            //防切屏次数
            if (!data) return false
            this.combination = data.combination
            this.switchScreenNum = data.switchScreenNum
            if (this.switchScreenNum > 0) {
                window.addEventListener('visibilitychange', this.cutScreen)
            }

            this.historyExamInfo = JSON.parse(sessionStorage.getItem('historyExamInfo'))
            if (this.historyExamInfo && this.historyExamInfo.examId === this.examParams.examId) {
                this.questionsList = this.historyExamInfo.questionsList

                this.examTotal = this.questionsList.length
                let rightCount = this.historyExamInfo.allAnswer.filter(val => {
                    if (val.answer) {
                        return val.answer.length > 0
                    }
                })
                this.rightCount = rightCount.length
                this.allAnswer = this.historyExamInfo.allAnswer
                // this.currentQuestion = this.questionsList[
                //     this.historyExamInfo.currentIndex - 1
                // ];
                // 解决题目数量为1或2考中人脸识别报错问题
                if (this.historyExamInfo.currentIndex === 0) {
                    this.currentQuestion = this.questionsList[this.historyExamInfo.currentIndex]
                } else {
                    this.currentQuestion = this.questionsList[this.historyExamInfo.currentIndex - 1]
                }
                this.halfTime = this.examParams.seconds - this.historyExamInfo.examtime
                this.currentRanking = this.historyExamInfo.currentIndex
                console.log('试题列表')
                this.findSomeOne()
            } else {
                this.examtime = this.examParams.seconds
                this.questionsList = data.questions
                this.examTotal = this.questionsList.length
                this.currentQuestion = this.questionsList[0]
            }

            // 填空题输入框问题
            this.questionsList.forEach((item, index) => {
                if (+item.type === 7) {
                    // 组合题
                    item.subDtoList.forEach((val, idx) => {
                        val.questionIdx = idx // 记录当前子题的下标
                        if (idx == 0) val.first = true // 记录第一个
                        if (idx + 1 == item.subDtoList.length) {
                            val.lastOne = true // 是否为最后一个
                        }
                        // 组合题填空
                        this.completionFn(val)
                    })
                    if (index == 0) {
                        // 只有组合题的时候，默认选中第一个
                        this.subQuestion = item.subDtoList[0]
                        this.combinationFlag = true
                    }
                }
                // 普通填空
                this.completionFn(item)
                if (data.lastQuestionId === item.questionId) {
                    this.currentQuestion = this.questionsList[index + 1]
                    this.findSomeOne()
                    this.currentRanking = index + 2
                }
            })
            console.log(this.questionsList, 'questionsList')

            this.showpage = data ? 'canTest' : ''
            let faceflag = localStorage.getItem('faceidentify')
            if (
                this.historyExamInfo &&
                this.historyExamInfo.examtime === this.examtime / 2 &&
                (!faceflag || faceflag === '0')
            ) {
                console.log('时间过半人脸识别')
                this.openFaceCheck('pending')
            } else {
                if (+this.examParams.seconds !== 0) {
                    this.countDown()
                }
            }
            if (
                sessionStorage.getItem('examStatus') === 'commit' ||
                (this.historyExamInfo && this.historyExamInfo.status !== 'refresh')
            ) {
                this.removeItem()
            }
        },
        // 填空题输入框问题
        completionFn(completion) {
            const item = completion
            if ([6].includes(item.type)) {
                if (!item.completionAnswer) {
                    item.completionAnswer = []
                    for (let i = 0; i < item.completeInputNum; i++) {
                        item.completionAnswer.push({ answer: '' })
                    }
                }
            }
            if (item.userAnswer) {
                item.responds = 1
                this.allAnswer.push({
                    answer: item.userAnswer,
                    mark: item.mark || 0,
                    questionId: item.questionId,
                    questionType: item.type
                })
                if ([6].includes(item.type)) {
                    item.completionAnswer = []
                    const userAnswer = item.userAnswer.split(',')
                    console.log(userAnswer, 'userAnswer-zizizi')
                    userAnswer.forEach(item1 => {
                        item.completionAnswer.push({ answer: item1 })
                    })
                }
            }
        },
        // 试卷详情回显
        async findUserPaperInfo() {
            const { data } = await this.$api.exam.findUserPaperInfo({
                userPaperId: this.examParams.userPaperId
            })
            this.paperInfo = {
                emptyCount: data.emptyCount,
                errorCount: data.errorCount,
                rightCount: data.rightCount
            }
            this.showpage = data ? 'canTest' : ''
            this.duration = data.examName
            this.isValid = data.isValid
            this.combination = data.combination
            this.questionsList = data.examQuestionInfos
            this.examTotal = this.questionsList.length
            this.currentQuestion = this.questionsList[0]
            this.questionsList.forEach((item, index) => {
                if (item.type == 7) {
                    // 组合题
                    item.subDtoList.forEach((val, idx) => {
                        val.questionIdx = idx // 记录当前子题的下标
                        if (idx == 0) val.first = true // 记录第一个
                        if (idx + 1 == item.subDtoList.length) {
                            val.lastOne = true // 是否为最后一个
                        }
                    })
                    if (index == 0) {
                        // 只有组合题的时候，默认选中第一个
                        this.subQuestion = item.subDtoList[0]
                        this.combinationFlag = true
                    }
                }
            })
        },

        // 语音播报
        audioplay(text) {
            var ttsDiv = document.getElementById('examTaking')
            var au1 = '<audio id="tts_autio_id" autoplay="autoplay">'
            var sss =
                '<source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=5&text=' +
                text +
                '" type="audio/mpeg">'
            var eee = '<embed id="tts_embed_id" height="0" width="0" src="">'
            var au2 = '</audio>'
            ttsDiv.innerHTML = au1 + sss + eee + au2
        },
        refreshParam() {
            this.pushState()
            window.history.pushState(null, null, '#')
            console.log(this.moreChoose, 'this.moreChoose---refreshParam')
            this.repetAnswer(this.moreChoose)
            this.setHistory('refresh')
        },
        //屏幕常亮
        noSleep() {
            let noSleep = new this.$NoSleep()
            document.addEventListener(
                'click',
                function enableNoSleep() {
                    noSleep.enable()
                    document.removeEventListener('click', enableNoSleep, false)
                },
                false
            )
        },
        async cutScreen() {
            if (document.hidden) {
                let res = await this.$api.exam_live.switchScreen({ userPaperId: this.examParams.userPaperId })
                this.cutNum = this.cutNum + 1
                this.warningDialogVisible = true
                sessionStorage.setItem('hiddenpageTime', Date.parse(new Date()))
                sessionStorage.setItem('examSurplusTime', this.examtime)
            } else {
                this.setWarning()
                sessionStorage.setItem('openpageTime', Date.parse(new Date()))
                let time = (sessionStorage.getItem('openpageTime') - sessionStorage.getItem('hiddenpageTime')) / 1000
                // this.examtime =
                //     sessionStorage.getItem("examSurplusTime") - time;
                // console.log(this.examtime, '222222')
                // this.countDown(this.examtime);
                // 解决 sessionStorage.getItem("examSurplusTime") 为null时 自动交卷问题
                if (sessionStorage.getItem('examSurplusTime')) {
                    this.examtime = sessionStorage.getItem('examSurplusTime') - time
                    console.log(this.examtime, '222222', sessionStorage.getItem('examSurplusTime'))
                    this.countDown(this.examtime)
                }
            }
        },
        know() {
            this.warningDialogVisible = false
            if (this.cutNum == this.switchScreenNum) {
                // this.allCommit('cut');
            }
        },
        // 返回上题
        onTopic() {
            // this.justWatch ? this.$router.push({
            //         //   path: this.isValid ? "/examresults" : '/examIsValid',
            //           path: "/examresults",
            //           query: {
            //               id: this.examParams.userPaperId,
            //               businessType: this.$route.query.businessType,
            //               businessId: this.$route.query.businessId,
            //               trainItemExamId: this.$route.query.trainItemExamId,
            //               backType: this.$route.query.backType,
            //               showbtn: this.$route.query.showbtn,
            //               backPath: this.$route.query.backPath,
            //               goodsId: this.$route.query.goodsId,
            //               goodsKind: this.$route.query.goodsKind,
            //           }
            //       })
            //     : this.commitPaper();
            this.justWatch
                ? this.$router.push({
                      path: '/examlistDetails',
                      query: {
                          trainId: this.$route.query.businessId,
                          type: this.$route.query.businessType,
                          contentId: this.$route.query.examId,
                          backType: this.$route.query.backType,
                          backPath: this.$route.query.backPath,
                          goodsId: this.$route.query.goodsId,
                          goodsKind: this.$route.query.goodsKind
                      }
                  })
                : this.commitPaper()
        },
        // 标记按钮
        handleMark() {
            let status = this.$refs.mark.dataset.status
            this.ismark = +status === 0 ? 1 : 0
            if (this.combinationFlag) {
                this.subQuestion.mark = this.ismark
            } else {
                this.questionsList[this.currentRanking - 1].mark = this.ismark
            }
            this.biaojiImg =
                this.ismark === 0
                    ? require('../../../assets/images/exam/nobiaoji.png')
                    : require('../../../assets/images/exam/biaoji.png')
            let params = {
                answer:
                    this.chooseNum || this.moreanswer
                        ? this.moreanswer.length > 0
                            ? this.moreanswer.toString()
                            : this.chooseNum
                        : '',
                mark: this.currentQuestion.mark === undefined ? 0 : this.currentQuestion.mark,
                questionId: this.currentQuestion.questionId,
                questionType: this.currentQuestion.type,
                subQuestionId: this.subQuestion.id ?? null,
                subQuestionType: this.subQuestion.type ?? null
            }
            if (this.combinationFlag) {
                params.mark = this.subQuestion.mark === undefined ? 0 : this.subQuestion.mark
            }
            this.repetAnswer(params)
            this.currentParams = params
        },
        pushState() {
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                history.pushState(null, null, '#')
                // 给 popstate 绑定一个方法 监听页面刷新
                window.addEventListener('popstate', this.backChange, false) //false阻止默认事件
            }
        },
        setHistory(val) {
            console.log('setHistory', this.allAnswer)
            let historyExamInfo = {
                examtime: this.examtime,
                questionsList: this.questionsList,
                currentIndex:
                    this.currentRanking === this.examTotal
                        ? this.questionsList.indexOf(this.currentQuestion)
                        : this.questionsList.indexOf(this.currentQuestion) + 1,
                examId: this.examParams.examId,
                allAnswer: this.allAnswer,
                userPaperId: this.examParams.userPaperId,
                businessType: this.$route.query.businessType,
                businessId: this.$route.query.businessId,
                trainItemExamId: this.$route.query.trainItemExamId,
                backType: this.$route.query.backType,
                backPath: this.$route.query.backPath,
                goodsId: this.$route.query.goodsId,
                goodsKind: this.$route.query.goodsKind
            }
            val ? (historyExamInfo.status = val) : ''
            sessionStorage.setItem('historyExamInfo', JSON.stringify(historyExamInfo))
        }
    },
    mounted() {
        this.noSleep()
        this.pushState()
        window.history.pushState(null, null, '#')
        if (localStorage.getItem('faceidentify') === '0') {
            localStorage.removeItem('faceidentify')
        }
        this.examParams = { ...this.$route.query }
        this.isFaceRecogCommitExam = localStorage.getItem('isFaceRecogCommitExam')
        this.isFaceRecogDuringExam = localStorage.getItem('isFaceRecogDuringExam')
        const queryType = this.$route.query.type
        if (queryType === 'examInfo' || queryType === 'historical') {
            this.findUserPaperInfo()
            this.justWatch = true
        } else {
            if (sessionStorage.getItem('secondsExam') && sessionStorage.getItem('allowCommitDurationExam')) {
                this.findQuestForExam()
                this.autoTime = sessionStorage.getItem('autoTime')
                window.addEventListener('beforeunload', this.refreshParam)
                window.addEventListener('pagehide', this.refreshParam)
                window.addEventListener(
                    'offline',
                    () => {
                        this.$toast('网络异常')
                    },
                    false
                )
            } else {
                this.showpage = 'notTest'
            }
        }
    }
}
</script>

<style scoped lang="less">
@import '../asset/examTaking.less';
</style>
<style lang="less">
.examTakingDialog {
    .van-dialog__footer {
        width: 100% !important;
    }
}
.failTy {
    background-color: rgba(236, 99, 94, 0.9);
}
.van-toast {
    height: 25px !important;
    border-radius: 20px !important;
    line-height: 1.0667rem !important;
    font-size: 14px !important;
}
@import '../asset/css/examTaking1.less';
.dtconfirm {
    .van-dialog__footer {
        width: 100%;
    }
}
</style>
